<template>
  <div class="inner-box">
    <el-form size="mini" :model="form" ref="catInfoForm">
      <el-row>
        <el-col>
          <el-col :span="3">
            <el-form-item label="우편번호">
              <el-input v-model="form.zipCd"></el-input>
              <el-input v-model="form.zipId" v-show='false'></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="시명">
              <el-input v-model="form.siNm"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="구명">
              <el-input v-model="form.guNm"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="동명">
              <el-input v-model="form.dongNm"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-form-item label="리명">
              <el-input v-model="form.riNm"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-form-item label="도서명">
              <el-input v-model="form.islandNm"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-form-item label="번지">
              <el-input v-model="form.bunji"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="건물명">
              <el-input v-model="form.buildingNm"></el-input>
            </el-form-item>
          </el-col>

        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item>
              <div class="upload-area" style="width: 100%; display: flex;">
                <div class="input-area">
                  <el-input v-model="file.name" readonly></el-input>
                  <input ref="file" type="file" v-show="false" accept=".txt" @change="fileChangeEvent"/>
                </div>
                <div class="btn-wrap btn-type1">
                  <el-button type="primary" @change="fileChangeEvent" @click="searchFile">파일첨부</el-button>
                  <el-button type="info"  @click="uploadFile">업로드</el-button>
                </div>
              </div>
          </el-form-item>
        </el-col>
      </el-row>

    </el-form>
  </div>
</template>

<script>
export default {
  name: "zipInfo",
  props: ['zipDetail'],
  data() {
    return {
      form: {
        zipKey: "",
        zipNm: "",
        zipId: "",
        parentId: "",
        TopKey: "",
        zipIdx: "",
        description: "",
        zipCd: "",
        siNm: "",
        guNm: "",
        dongNm: "",
        riNm: "",
        islandNm: "",
        bunji: "",
        buildingNm: "",
      },
      file: {
        name: undefined
      },
      fileLoaded: false,
      // eslint-disable-next-line vue/no-dupe-keys
    };
  },
  methods: {
    setzipInfo() {
      Object.assign(this.form, this.zipDetail);
    },
    searchFile() {
      //console.log("this.$refs. ", this.$refs.file);
      this.$refs.file.click();
    },
    fileChangeEvent() {
      this.file = this.$refs.file.files[0] || {
        name: undefined
      }
      this.fileLoaded = this.$refs.file.files[0] !== undefined
    },
    uploadFile() {
      if (this.fileLoaded) {
        let form = new FormData();
        form.append('file', this.file);

        this.$store.commit('loading');
        this.$http.post('/api/zipMng/file/upload', form, {timeout: 60000*60},{
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(response => {
          this.$swal({
            type: 'success',
            text: response.data
          }).then(this.query)
          if (response.data.length == 0){
            this.$swal({
              type: 'error',
              html: '오류가 발생했습니다 <br> 파일을 확인해주세요.'
            });
          }else{
            this.$swal({
              type: 'success',
              text: '업로드에 성공했습니다.'
            });
          }
          this.subData = response.data;
          return response;
        }).catch(e => {
          this.$swal({type: 'error', text: e.response.data.message});
          return e;
        }).finally(() => {
          this.enableUploadArea = false;
          this.$store.commit('finish');
        })
      } else {
        this.$swal({
          type: 'warning',
          text: '업로드할 파일을 선택해주세요.'
        })
      }
    },
  },
  watch: {
    zipDetail() {
      this.setzipInfo();
    }
  }
}

</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 0;
  // &:last-child {
  //   margin-bottom: 0;
  // }
}
.el-form {
  border: 1px solid #c7c7c7;
  padding: 10px 0 0 10px;
  border-radius: 5px;
}
.el-form-item {
  margin-right: 10px;
  // &:last-child {
  //   margin-right: 0;
  // }
}
.large-textarea{
  padding: 0 24px !important
}

</style>